import { rhSpecs } from "./rhSteelTable";

export interface SteelSubCategory {
  id: string;
  name: string;
}

export type SubTypeOption = { id: string; name: string; count: number };

export interface ItemCategory {
  id: string;
  name: string;
  icon: string;
  count: number;
  subCategories?: SteelSubCategory[];
}

export interface Item {
  id: string;
  name: string;
  category: string;
  categoryId: string;
  steelType?: string;
  spec?: string;
  material?: string;
  description?: string;
  isActive: boolean;
  isPreset?: boolean;
}

export const steelSubCategories: SteelSubCategory[] = [
  { id: "TUBE", name: "方管" },
  { id: "BOX", name: "箱型鋼" },
  // { id: "H", name: "H型鋼" },
  { id: "RH", name: "熱軋H型鋼" },
  { id: "BH", name: "焊接H型鋼" },
  { id: "I", name: "I型鋼" },
  { id: "L", name: "角鋼" },
  { id: "U", name: "槽鋼" },
  { id: "BT", name: "BT型鋼" },
  { id: "CT", name: "CT型鋼" },
  { id: "T", name: "T型鋼" },
  { id: "C", name: "C型鋼" },
  { id: "PIPE", name: "圓管" },
  { id: "FB", name: "扁鋼" },
  { id: "RB", name: "圓棒" },
];

export const legacySteelSubCategories: SteelSubCategory[] = [
  { id: "H", name: "H型鋼" },
];

export const allSteelSubCategories: SteelSubCategory[] = [
  ...steelSubCategories,
  ...legacySteelSubCategories,
];

export const screwSubCategories: SteelSubCategory[] = [
  { id: "六角螺栓", name: "六角螺栓" },
  { id: "六角螺帽", name: "六角螺帽" },
  { id: "墊圈", name: "墊圈" },
  { id: "高張力螺絲組", name: "高張力螺絲組" },
  { id: "錨栓", name: "錨栓" },
  { id: "剪力釘", name: "剪力釘" },
];

export const steelSpecs: Record<string, string[]> = {
  TUBE: [
    "40X40X1.6",
    "40X40X2.3",
    "50X20X1.6",
    "50X20X2.3",
    "50X30X1.6",
    "50X30X2.3",
    "50X50X1.6",
    "50X50X2.3",
    "50X50X3.2",
    "60X30X1.6",
    "60X30X2.3",
    "60X30X3.2",
    "60X60X1.6",
    "60X60X2.3",
    "60X60X3.2",
    "75X20X1.6",
    "75X20X2.3",
    "75X45X1.6",
    "75X45X2.3",
    "75X45X3.2",
    "75X75X1.6",
    "75X75X2.3",
    "75X75X3.2",
    "75X75X4.5",
    "80X40X1.6",
    "80X40X2.3",
    "80X40X3.2",
    "80X80X2.3",
    "80X80X3.2",
    "80X80X4.5",
    "90X45X2.3",
    "90X45X3.2",
    "90X90X2.3",
    "90X90X3.2",
    "100X20X1.6",
    "100X20X2.3",
    "100X40X1.6",
    "100X40X2.3",
    "100X40X4.2",
    "100X50X1.6",
    "100X50X2.3",
    "100X50X3.2",
    "100X50X4.5",
    "100X100X2.3",
    "100X100X3.2",
    "100X100X4",
    "100X100X4.5",
    "100X100X6",
    "100X100X9",
    "100X100X12",
    "125X40X1.6",
    "125X40X2.3",
    "125X75X2.3",
    "125X75X3.2",
    "125X75X4",
    "125X75X4.5",
    "125X75X6",
    "125X125X3.2",
    "125X125X4.5",
    "125X125X5",
    "125X125X6",
    "125X125X9",
    "125X125X12",
    "150X75X3.2",
    "150X80X4.5",
    "150X80X5",
    "150X80X6",
    "150X100X3.2",
    "150X100X4.5",
    "150X100X6",
    "150X100X9",
    "150X150X4.5",
    "150X150X5",
    "150X150X6",
    "150X150X9",
    "175X175X4.5",
    "175X175X5",
    "175X175X6",
    "200X100X4.5",
    "200X100X6",
    "200X100X9",
    "200X150X4.5",
    "200X150X6",
    "200X150X9",
    "200X200X4.5",
    "200X200X6",
    "200X200X8",
    "200X200X9",
    "200X200X12",
    "250X150X6",
    "250X150X9",
    "250X150X12",
    "250X250X5",
    "250X250X6",
    "250X250X8",
    "250X250X9",
    "250X250X12",
    "250X250X16",
    "300X200X6",
    "300X200X9",
    "300X200X12",
    "300X300X4.5",
    "300X300X6",
    "300X300X9",
    "300X300X12",
    "300X300X16",
    "300X300X19",
    "350X150X6",
    "350X150X9",
    "350X150X12",
    "350X350X9",
    "350X350X12",
    "350X350X16",
    "350X350X19",
    "350X350X22",
    "400X200X6",
    "400X200X9",
    "400X200X12",
    "400X400X9",
    "400X400X12",
    "400X400X16",
    "400X400X19",
    "400X400X22",
    "400X400X25",
    "450X450X9",
    "450X450X12",
    "450X450X16",
    "450X450X19",
    "450X450X22",
    "450X450X25",
    "450X450X28",
    "450X450X32",
    "500X500X12",
    "500X500X16",
    "500X500X19",
    "500X500X22",
    "500X500X25",
    "500X500X28",
    "500X500X32",
    "550X550X16",
    "550X550X19",
    "550X550X22",
    "550X550X25",
    "550X550X28",
    "550X550X32",
    "600X600X16",
    "600X600X19",
    "600X600X22",
    "600X600X25",
    "600X600X28",
    "600X600X32",
    "650X650X16",
    "650X650X19",
    "650X650X22",
    "650X650X25",
    "650X650X28",
    "650X650X32",
    "700X600X16",
    "700X600X19",
    "700X600X22",
    "700X600X25",
    "700X600X28",
    "700X600X32",
    "700X700X16",
    "700X700X19",
    "700X700X22",
    "700X700X25",
    "700X700X28",
    "700X700X32",
    "750X750X19",
    "750X750X22",
    "750X750X25",
    "750X750X28",
    "750X750X32",
    "800X600X19",
    "800X600X22",
    "800X600X25",
    "800X600X28",
    "800X600X32",
    "800X700X19",
    "800X700X22",
    "800X700X25",
    "800X700X28",
    "800X700X32",
    "800X800X19",
    "800X800X22",
    "800X800X25",
    "800X800X28",
    "800X800X32",
    "850X850X19",
    "850X850X22",
    "850X850X25",
    "850X850X28",
    "850X850X32",
    "900X650X19",
    "900X650X22",
    "900X650X25",
    "900X650X28",
    "900X650X32",
    "900X700X19",
    "900X700X22",
    "900X700X25",
    "900X700X28",
    "900X700X32",
    "900X900X19",
    "900X900X22",
    "900X900X25",
    "900X900X28",
    "900X900X32",
    "950X950X22",
    "950X950X25",
    "950X950X28",
    "950X950X32",
    "1000X700X22",
    "1000X700X25",
    "1000X700X28",
    "1000X700X32",
    "1000X800X22",
    "1000X800X25",
    "1000X800X28",
    "1000X800X32",
    "1000X1000X22",
    "1000X1000X25",
    "1000X1000X28",
    "1000X1000X32",
  ],
  BOX: [
    "200X200X9X9",
    "300X300X9X9",
    "300X300X19X19",
    "300X300X20X20",
    "350X350X19X19",
    "400X300X19X19",
    "400X350X22X22",
    "400X400X25X25",
    "450X350X19X19",
    "500X350X16X16",
    "500X350X19X19",
    "500X450X19X19",
    "500X500X25X25",
    "500X600X25X25",
    "500X600X30X30",
    "500X600X32X32",
    "500X600X35X35",
    "550X550X20X20",
    "550X550X25X25",
    "600X300X16X16",
    "600X300X20X20",
    "600X400X16X16",
    "600X400X19X19",
    "600X400X22X22",
    "600X500X32X32",
    "600X500X35X35",
    "600X600X16X16",
    "600X600X19X19",
    "600X600X20X20",
    "600X600X22X22",
    "600X600X25X25",
    "600X600X28X28",
    "600X600X30X30",
    "600X600X32X32",
    "600X600X35X35",
    "650X400X16X16",
    "700X700X35X35",
    "708X708X35X35",
    "900X300X19X19",
    "900X300X22X22",
    "900X400X16X16",
    "900X400X19X19",
    "900X400X22X22",
    "900X400X25X25",
    "900X400X28X28",
    "900X600X25X25",
    "1170X400X16X16",
    "1170X400X19X19",
    "1170X400X22X22",
    "1170X400X25X25",
    "1200X400X19X19",
    "1200X400X22X22",
    "1200X400X25X25",
    "1200X400X28X28",
    "1200X700X25X25",
    "1400X400X19X19",
    "1400X400X22X22",
    "1400X400X25X25",
    "1400X400X28X28",
    "1450X400X22X22",
    "1450X400X25X25",
    "1450X400X28X28",
    "1550X400X22X22",
    "1550X400X25X25",
    "1650X400X28X28",
    "1650X400X32X32",
  ],
  H: [
    "100X50X5X7",
    "100X100X6X8",
    "125X60X6X8",
    "125X125X6.5X9",
    "148X100X6X9",
    "150X75X5X7",
    "150X150X7X10",
    "175X90X5X8",
    "175X175X7.5X11",
    "194X150X6X9",
    "198X99X4.5X7",
    "200X100X5.5X8",
    "200X200X8X12",
    "200X204X12X12",
    "244X175X7X11",
    "248X124X5X8",
    "250X125X6X9",
    "250X250X9X14",
    "250X255X14X14",
    "294X200X8X12",
    "294X302X12X12",
    "298X149X5.5X8",
    "300X150X6.5X9",
    "300X300X10X15",
    "300X305X15X15",
    "304X301X11X17",
    "312X303X13X21",
    "318X307X17X24",
    "326X310X20X28",
    "336X249X8X12",
    "338X351X13X13",
    "340X250X9X14",
    "344X348X10X16",
    "344X354X16X16",
    "346X174X6X9",
    "350X175X7X11",
    "350X252X11X19",
    "350X350X12X19",
    "350X357X19X19",
    "356X256X15X22",
    "360X354X16X24",
    "364X258X17X26",
    "368X356X18X28",
    "378X358X20X33",
    "386X299X9X14",
    "388X402X15X15",
    "390X300X10X16",
    "394X398X11X18",
    "394X405X18X18",
    "396X199X7X11",
    "400X200X8X13",
    "400X304X14X21",
    "400X400X13X21",
    "400X408X21X21",
    "410X308X18X26",
    "414X405X18X28",
    "418X310X20X30",
    "428X407X20X35",
    "434X299X10X15",
    "440X300X11X18",
    "446X199X8X12",
    "446X302X13X21",
    "450X200X9X14",
    "450X304X15X23",
    "456X201X10X17",
    "458X306X17X27",
    "458X417X30X50",
    "466X205X14X22",
    "468X308X19X32",
    "478X208X17X28",
    "482X300X11X15",
    "488X300X11X18",
    "494X302X13X21",
    "496X199X9X14",
    "498X432X45X70",
    "500X200X10X16",
    "500X304X15X24",
    "506X201X11X19",
    "510X306X17X29",
    "512X202X12X22",
    "518X205X15X25",
    "518X310X21X33",
    "528X208X18X30",
    "532X314X25X40",
    "536X210X20X34",
    "548X215X25X40",
    "582X300X12X17",
    "588X300X12X20",
    "594X302X14X23",
    "596X199X10X15",
    "600X200X11X17",
    "600X304X16X26",
    "606X201X12X20",
    "608X306X18X30",
    "612X202X13X23",
    "616X308X20X34",
    "618X205X16X26",
    "626X207X18X30",
    "628X312X24X40",
    "634X209X20X34",
    "646X214X25X40",
    "692X300X13X20",
    "700X300X13X24",
    "708X302X15X28",
    "712X306X19X30",
    "718X308X21X33",
    "732X311X24X40",
    "792X300X14X22",
    "800X300X14X26",
    "808X302X16X30",
    "890X299X15X23",
    "900X300X16X28",
    "912X302X18X34",
  ],
  RH: rhSpecs,
  BH: [
    "344X348X10X16",
    "350X350X12X19",
    "356X352X14X22",
    "390X300X10X16",
    "394X398X11X18",
    "396X199X7X11",
    "400X200X6X16",
    "400X200X8X13",
    "400X400X13X21",
    "404X200X6X17",
    "414X405X18X28",
    "428X407X20X35",
    "440X300X11X18",
    "446X199X8X12",
    "450X200X6X16",
    "450X200X9X14",
    "454X200X6X18",
    "458X417X30X50",
    "482X300X11X15",
    "488X300X11X18",
    "496X199X9X14",
    "498X432X45X70",
    "500X200X7X16",
    "500X200X10X16",
    "500X300X7X16",
    "506X200X7X19",
    "506X201X11X19",
    "506X300X7X19",
    "550X200X8X19",
    "550X300X8X19",
    "556X200X8X22",
    "556X300X8X22",
    "582X300X12X17",
    "588X300X12X20",
    "594X302X14X23",
    "596X199X10X15",
    "600X200X8X19",
    "600X200X11X17",
    "600X300X8X18",
    "600X300X8X22",
    "606X200X8X22",
    "606X201X12X20",
  ],
  I: [
    "75X75X5X8",
    "100X75X5X8",
    "125X75X5.5X9.5",
    "150X75X5.5X9.5",
    "150X125X8.5X14",
    "180X100X6X10",
    "200X100X7X10",
    "200X150X9X16",
    "250X125X7.5X12.5",
    "250X125X10X19",
    "300X150X8X13",
    "300X150X10X18.5",
    "300X150X11.5X22",
    "350X150X9X15",
    "350X150X12X24",
    "400X150X10X18",
    "400X150X12.5X25",
    "450X175X11X20",
    "450X175X13X26",
    "500X190X11.5X23",
    "500X190X15X30",
    "600X190X13X25",
    "600X190X16X35",
  ],
  L: [
    "20X20X3",
    "25X25X3",
    "25X25X5",
    "30X30X3",
    "30X30X5",
    "35X35X3",
    "35X35X5",
    "38X38X4",
    "40X20X3",
    "40X20X5",
    "40X40X3",
    "40X40X5",
    "45X45X4",
    "45X45X6",
    "45X45X8",
    "50X35X4",
    "50X35X6",
    "50X50X4",
    "50X50X6",
    "50X50X8",
    "60X50X5",
    "60X50X7",
    "60X60X4",
    "60X60X5",
    "60X60X6",
    "60X60X7",
    "65X50X5",
    "65X50X7",
    "65X50X9",
    "65X65X6",
    "65X65X8",
    "65X65X10",
    "70X60X6",
    "70X60X8",
    "70X60X10",
    "70X70X6",
    "70X70X8",
    "70X70X10",
    "75X50X6",
    "75X50X8",
    "75X50X9",
    "75X50X10",
    "75X65X6",
    "75X65X8",
    "75X65X10",
    "75X75X6",
    "75X75X9",
    "75X75X12",
    "75X75X14",
    "80X60X6",
    "80X60X8",
    "80X60X10",
    "80X70X6",
    "80X70X9",
    "80X70X12",
    "80X80X6",
    "80X80X9",
    "80X80X12",
    "90X60X6",
    "90X60X9",
    "90X60X12",
    "90X75X6",
    "90X75X9",
    "90X75X12",
    "90X80X7",
    "90X80X10",
    "90X80X13",
    "90X90X6",
    "90X90X7",
    "90X90X10",
    "90X90X13",
    "90X90X15",
    "100X50X7",
    "100X65X7",
    "100X65X9",
    "100X65X12",
    "100X75X7",
    "100X75X10",
    "100X75X13",
    "100X80X7",
    "100X80X10",
    "100X80X13",
    "100X90X7",
    "100X90X9",
    "100X90X13",
    "100X100X7",
    "100X100X10",
    "100X100X13",
    "100X100X15",
    "100X100X17",
    "120X120X8",
    "125X75X7",
    "125X75X9",
    "125X75X10",
    "125X75X13",
    "125X90X7",
    "125X90X9",
    "125X90X10",
    "125X90X13",
    "130X130X9",
    "130X130X12",
    "130X130X15",
    "130X130X17",
    "150X75X7",
    "150X75X9",
    "150X75X12",
    "150X90X9",
    "150X90X12",
    "150X90X15",
    "150X100X9",
    "150X100X10",
    "150X100X12",
    "150X100X15",
    "150X150X11",
    "150X150X12",
    "150X150X15",
    "150X150X19",
    "150X150X22",
    "175X90X9",
    "175X90X12",
    "175X90X15",
    "175X100X10",
    "175X100X12",
    "175X100X14",
    "175X175X12",
    "175X175X15",
    "200X90X11",
    "200X90X13",
    "200X90X15",
    "200X100X11",
    "200X100X13",
    "200X100X15",
    "200X200X15",
    "200X200X20",
    "200X200X25",
    "200X200X27",
    "200X200X29",
    "250X250X25",
    "250X250X35",
  ],
  U: [
    "65X32X4X6",
    "75X40X5X7",
    "100X50X5X7.5",
    "125X65X6X8",
    "150X70X6X8.5",
    "150X75X6.5X10",
    "150X75X9X12.5",
    "150X90X6X10.5",
    "150X90X9X14",
    "150X90X12X17.5",
    "180X75X7X10.5",
    "180X75X10X13.5",
    "180X75X12X15.5",
    "180X90X7.5X12.5",
    "180X90X10X15.5",
    "180X90X12.5X18.5",
    "200X70X7X10",
    "200X80X7.5X11",
    "200X80X9X13.5",
    "200X80X10.5X15.5",
    "200X90X8X13.5",
    "200X90X10X15.5",
    "200X90X12X18",
    "230X80X8X12",
    "230X80X10X15",
    "230X80X12X17.5",
    "230X90X8.5X13.5",
    "230X90X10.5X16",
    "230X90X12.5X18.5",
    "250X80X8X12.5",
    "250X80X10X15",
    "250X80X12X17.5",
    "250X90X9X13",
    "250X90X11X14.5",
    "250X90X13X18",
    "280X100X9X13",
    "280X100X11.5X16",
    "280X100X13X18",
    "300X90X9X13",
    "300X90X10X15.5",
    "300X90X10.5X15.5",
    "300X90X12X16",
    "300X90X13X19.5",
    "300X100X10X16",
    "300X100X12X18",
    "300X100X14X20",
    "380X100X10.5X16",
    "380X100X13X16.5",
    "380X100X13X20",
    "380X100X15.5X23.5",
    "425X100X10.5X16",
    "425X100X13X19.5",
    "425X100X15.5X23.5",
  ],
  BT: [
    "100X140X8X8",
    "100X150X8X8",
    "286X300X28X45",
    "290X300X20X22",
    "290X300X20X25",
    "290X300X20X28",
    "290X300X20X32",
    "290X300X20X36",
    "311X250X28X40",
    "311X250X30X40",
    "317X250X16X28",
  ],
  CT: [
    "50X50X5X7",
    "50X100X6X8",
    "62.5X60X6X8",
    "62.5X125X6.5X9",
    "74X100X6X9",
    "75X75X5X7",
    "75X150X7X10",
    "87.5X90X5X8",
    "87.5X175X7.5X11",
    "97X150X6X9",
    "99X99X4.5X7",
    "100X100X5.5X8",
    "100X200X8X12",
    "100X204X12X12",
    "122X175X7X11",
    "124X124X5X8",
    "125X125X6X9",
    "125X250X9X14",
    "125X255X14X14",
    "147X200X8X12",
    "147X302X12X12",
    "149X149X5.5X8",
    "150X150X6.5X9",
    "150X300X10X15",
    "150X305X15X15",
    "170X250X9X14",
    "172X348X10X16",
    "173X174X6X9",
    "175X175X7X11",
    "175X350X12X19",
    "194X402X15X15",
    "195X300X10X16",
    "197X398X11X18",
    "198X199X7X11",
    "200X200X8X13",
    "200X400X13X21",
    "200X408X21X21",
    "207X405X18X28",
    "214X407X20X35",
    "220X300X11X18",
    "223X199X8X12",
    "225X200X9X14",
    "241X300X11X15",
    "244X300X11X18",
    "248X199X9X14",
    "250X200X10X16",
    "253X201X11X19",
    "291X300X12X17",
    "294X300X12X20",
    "297X302X14X23",
    "298X199X10X15",
    "300X200X11X17",
    "303X201X12X20",
  ],
  T: [
    "150X200X8X13",
    "150X300X11X15",
    "212X300X12X20",
    "218X300X12X17",
    "311X250X28X40",
    "311X250X30X40",
    "314X250X22X28",
    "317X250X16X25",
    "317X250X16X28",
    "447X302X18X34",
    "647X302X18X34",
  ],
  C: [
    "60X30X10X1.6",
    "60X30X10X2.0",
    "60X30X10X2.3",
    "70X40X25X1.6",
    "75X35X15X2.3",
    "75X45X15X1.6",
    "75X45X15X2",
    "75X45X15X2.3",
    "90X45X20X1.6",
    "90X45X20X2.3",
    "90X45X20X3.2",
    "100X50X20X1.6",
    "100X50X20X2",
    "100X50X20X2.3",
    "100X50X20X2.8",
    "100X50X20X3.2",
    "100X50X20X4.0",
    "100X50X20X4.5",
    "120X40X20X3.2",
    "120X60X20X2.3",
    "120X60X20X3.2",
    "120X60X25X4.5",
    "125X50X20X2.3",
    "125X50X20X3.2",
    "125X50X20X4.0",
    "125X50X20X4.5",
    "150X50X20X2.3",
    "150X50X20X3.2",
    "150X50X20X4.5",
    "150X65X20X2.3",
    "150X65X20X3.2",
    "150X65X20X4.0",
    "150X75X20X3.2",
    "150X75X20X4.0",
    "150X75X20X4.5",
    "150X75X25X3.2",
    "150X75X25X4.0",
    "150X75X25X4.5",
    "200X75X20X3.2",
    "200X75X20X4.0",
    "200X75X20X4.5",
    "200X75X25X3.2",
    "200X75X25X4.0",
    "200X75X25X4.5",
    "250X75X25X4.5",
  ],
  PIPE: [
    "21.7X2",
    "27.2X2",
    "27.2X2.3",
    "34X2.3",
    "42.7X2.3",
    "42.7X2.5",
    "48.6X2.3",
    "48.6X2.5",
    "48.6X2.8",
    "48.6X3.2",
    "60.5X2.3",
    "60.5X3.2",
    "60.5X4",
    "76.3X2.8",
    "76.3X3.2",
    "76.3X4",
    "89.1X2.8",
    "89.1X3.2",
    "500X9",
    "500X12",
    "500X14",
    "508X9",
    "508X9.5",
    "508X12",
    "508X14",
    "508X16",
    "508X19",
    "508X22",
    "600X9",
    "600X12",
    "600X14",
    "600X16",
    "700X9",
    "700X12",
    "700X14",
    "700X16",
    "1016X12",
    "1016X14",
    "1016X16",
    "1016X19",
    "1016X22",
  ],
  FB: [
    "3X9",
    "3X12",
    "3X13",
    "3X16",
    "3X19",
    "3X22",
    "3X25",
    "3X32",
    "3X38",
    "3X44",
    "3X50",
    "3X65",
    "4.5X12",
    "4.5X13",
    "4.5X16",
    "4.5X19",
    "4.5X22",
    "4.5X25",
    "4.5X32",
    "4.5X38",
    "4.5X44",
    "4.5X50",
    "6X9",
    "6X12",
    "6X13",
    "6X16",
    "6X19",
    "6X22",
    "6X25",
    "6X32",
    "6X38",
    "6X44",
    "6X50",
    "6X60",
    "6X65",
    "6X75",
    "6X90",
    "6X100",
    "6X125",
    "8X25",
    "8X32",
    "8X38",
    "8X44",
    "8X50",
    "8X65",
    "8X75",
    "8X90",
    "8X100",
    "8X125",
    "9X16",
    "9X19",
    "9X22",
    "9X25",
    "9X32",
    "9X38",
    "9X44",
    "9X50",
    "9X60",
    "9X65",
    "9X75",
    "9X90",
    "9X100",
    "9X125",
    "9X150",
    "9X180",
    "9X200",
    "9X230",
    "9X250",
    "12X19",
    "12X22",
    "12X25",
    "12X28",
    "12X32",
    "12X38",
    "12X44",
    "12X50",
    "12X65",
    "12X75",
    "12X90",
    "12X100",
    "12X125",
    "12X150",
    "12X180",
    "12X200",
    "12X230",
    "12X250",
    "12X280",
    "12X300",
    "13X53",
    "16X25",
    "16X32",
    "16X38",
    "16X44",
    "16X50",
    "16X53",
    "16X55",
    "16X65",
    "16X75",
    "16X90",
    "16X100",
    "16X125",
    "16X150",
    "16X180",
    "16X200",
    "16X230",
    "16X250",
    "16X280",
    "16X300",
    "19X32",
    "19X38",
    "19X44",
    "19X50",
    "19X65",
    "19X75",
    "19X90",
    "19X100",
    "19X125",
    "19X150",
    "19X180",
    "19X200",
    "19X230",
    "19X250",
    "19X280",
    "19X300",
    "22X50",
    "22X65",
    "22X75",
    "22X90",
    "22X100",
    "22X125",
    "22X150",
    "22X180",
    "22X200",
    "22X230",
    "22X250",
    "22X280",
    "22X300",
    "25X50",
    "25X65",
    "25X75",
    "25X90",
    "25X100",
    "25X125",
    "25X150",
    "25X180",
    "25X200",
    "25X230",
    "25X250",
    "25X280",
    "25X300",
    "28X100",
    "28X125",
    "28X150",
    "28X180",
    "28X200",
    "28X230",
    "28X250",
    "28X280",
    "28X300",
    "32X100",
    "32X125",
    "32X150",
    "32X180",
    "32X200",
    "32X230",
    "32X250",
    "32X280",
    "32X300",
    "36X100",
    "36X125",
    "36X150",
    "36X180",
    "36X200",
    "36X230",
    "36X250",
    "36X280",
    "36X300",
  ],
  RB: [
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "30",
    "32",
    "33",
    "34",
    "36",
    "38",
    "39",
    "40",
    "42",
    "44",
    "45",
    "46",
    "48",
    "50",
    "52",
    "55",
    "56",
    "60",
    "64",
    "65",
    "68",
    "70",
    "75",
    "80",
    "85",
    "90",
    "95",
    "100",
    "105",
    "110",
    "115",
    "120",
    "125",
    "130",
    "135",
    "140",
    "145",
    "150",
    "160",
    "165",
    "170",
    "180",
    "190",
    "200",
  ],
};

export const categories: ItemCategory[] = [
  { id: "all", name: "全部品項", icon: "box", count: 256 },
  {
    id: "steel",
    name: "型鋼",
    icon: "beam",
    count: 128,
    subCategories: steelSubCategories,
  },
  {
    id: "screw",
    name: "螺絲",
    icon: "screw",
    count: 60,
    subCategories: screwSubCategories,
  },
  { id: "parts", name: "鋼構配件", icon: "cog", count: 36 },
  { id: "consumables", name: "鋼構耗材", icon: "package", count: 12 },
  { id: "hardware", name: "五金配件", icon: "wrench", count: 20 },
  { id: "uncategorized", name: "未分類", icon: "help", count: 0 },
];

export const steelMaterials = [
  "43",
  "43A",
  "43C",
  "50",
  "55",
  "300W",
  "350W",
  "A36",
  "A53",
  "A242-42",
  "A242-46",
  "A242-50",
  "A307",
  "A325",
  "A441",
  "A441-40",
  "A441-42",
  "A441-46",
  "A441-50",
  "A490",
  "A500-GR.B",
  "A501",
  "A514-90",
  "A514-100",
  "A529-42",
  "A529-50",
  "A572",
  "A572-42",
  "A572-50",
  "A572-60",
  "A572-65",
  "A572-GR.50",
  "A588-42",
  "A588-46",
  "A588-50",
  "A852",
  "A992",
  "FE50",
  "FE360B",
  "FE430",
  "FE510",
  "GRA25-3",
  "GRA25-4.5",
  "GRA25-6",
  "GRA32-3",
  "GRA32-4.5",
  "GRA32-6",
  "GRA38-3",
  "GRA38-4.5",
  "GRA38-6",
  "GRA44-4.5",
  "GRA44-6",
  "GRA50-4.5",
  "GRA50-6",
  "GRA65-6",
  "GRA75-6",
  "GRA90-6",
  "GRA100-6",
  "GRTA_1",
  "GRTA_1_1/2",
  "GRTA_1_1/4",
  "GRTS_1",
  "GRTS_1_1/2",
  "GRTS_1_1/4",
  "SM400A",
  "SM400B",
  "SM400C",
  "SM490A",
  "SM490B",
  "SM490C",
  "SM490YA",
  "SM490YB",
  "SM520B",
  "SM520C",
  "SM570",
  "SN400A",
  "SN400B",
  "SN400C",
  "SN490A",
  "SN490B",
  "SN490C",
  "SN400YB",
  "SN490YB",
  "SN400YC",
  "SN490YC",
  "SS400",
  "SS490",
  "SUS304",
  "Steel_Undefined",
  "Steel_Zero_Wt",
  "SGHC Z12",
  "SGH400 Z12",
];

export const materials = ["SS400", "SUS304", "SUS316", "鍍鋅鋼", "不鏽鋼"];

function getSteelItemName(steelType: string, spec: string): string {
  const typeNames: Record<string, string> = {
    TUBE: "方管",
    BOX: "箱型鋼",
    H: "H型鋼",
    RH: "熱軋H型鋼",
    BH: "焊接H型鋼",
    I: "I型鋼",
    L: "角鋼",
    U: "槽鋼",
    BT: "BT型鋼",
    CT: "CT型鋼",
    T: "T型鋼",
    C: "C型鋼",
    PIPE: "圓管",
    FB: "扁鋼",
    RB: "圓棒",
  };
  return `${typeNames[steelType] || steelType} ${spec}`;
}

const presetSteelItems: Item[] = [
  {
    id: "preset-h-1",
    name: "H型鋼 300X300X10X15",
    category: "型鋼",
    categoryId: "steel",
    steelType: "H",
    spec: "300X300X10X15",
    material: "SS400",
    description: "CNS標準H型鋼，熱軋成型，適用於一般結構用途。",
    isActive: true,
    isPreset: true,
  },
  {
    id: "preset-h-2",
    name: "H型鋼 400X200X8X13",
    category: "型鋼",
    categoryId: "steel",
    steelType: "H",
    spec: "400X200X8X13",
    material: "SS400",
    description: "CNS標準H型鋼，熱軋成型，適用於柱樑結構。",
    isActive: true,
    isPreset: true,
  },
  {
    id: "preset-tube-1",
    name: "方管 100X100X4.5",
    category: "型鋼",
    categoryId: "steel",
    steelType: "TUBE",
    spec: "100X100X4.5",
    material: "SS400",
    description: "CNS標準方管，冷成型，適用於框架結構。",
    isActive: true,
    isPreset: true,
  },
  {
    id: "preset-tube-2",
    name: "方管 200X200X6",
    category: "型鋼",
    categoryId: "steel",
    steelType: "TUBE",
    spec: "200X200X6",
    material: "SS400",
    description: "CNS標準方管，冷成型，適用於重型結構。",
    isActive: true,
    isPreset: true,
  },
  {
    id: "preset-l-1",
    name: "角鋼 75X75X6",
    category: "型鋼",
    categoryId: "steel",
    steelType: "L",
    spec: "75X75X6",
    material: "SS400",
    description: "CNS標準等邊角鋼，熱軋成型，通用型號。",
    isActive: true,
    isPreset: true,
  },
  {
    id: "preset-l-2",
    name: "角鋼 100X100X10",
    category: "型鋼",
    categoryId: "steel",
    steelType: "L",
    spec: "100X100X10",
    material: "SS400",
    description: "CNS標準等邊角鋼，熱軋成型，適用於支撐結構。",
    isActive: true,
    isPreset: true,
  },
  {
    id: "preset-u-1",
    name: "槽鋼 150X75X6.5X10",
    category: "型鋼",
    categoryId: "steel",
    steelType: "U",
    spec: "150X75X6.5X10",
    material: "SS400",
    description: "CNS標準槽鋼，熱軋成型，適用於框架與支撐。",
    isActive: true,
    isPreset: true,
  },
  {
    id: "preset-pipe-1",
    name: "圓管 76.3X3.2",
    category: "型鋼",
    categoryId: "steel",
    steelType: "PIPE",
    spec: "76.3X3.2",
    material: "SS400",
    description: "CNS標準圓管，適用於欄杆與管架結構。",
    isActive: true,
    isPreset: true,
  },
  {
    id: "preset-fb-1",
    name: "扁鋼 12X100",
    category: "型鋼",
    categoryId: "steel",
    steelType: "FB",
    spec: "12X100",
    material: "SS400",
    description: "CNS標準扁鋼，熱軋成型，適用於連結板與加強肋。",
    isActive: true,
    isPreset: true,
  },
  {
    id: "preset-rb-1",
    name: "圓棒 25",
    category: "型鋼",
    categoryId: "steel",
    steelType: "RB",
    spec: "25",
    material: "SS400",
    description: "CNS標準圓棒，適用於錨栓與連結件。",
    isActive: true,
    isPreset: true,
  },
];

function generateSteelItems(): Item[] {
  const items: Item[] = [];
  let idCounter = 1;

  Object.entries(steelSpecs).forEach(([steelType, specs]) => {
    const sampleSpecs = specs.slice(0, 8);
    sampleSpecs.forEach((spec) => {
      items.push({
        id: `steel-${idCounter}`,
        name: getSteelItemName(steelType, spec),
        category: "型鋼",
        categoryId: "steel",
        steelType: steelType,
        spec: spec,
        material: "SS400",
        description: `${getSteelItemName(steelType, spec)}，符合 CNS 標準。`,
        isActive: true,
      });
      idCounter++;
    });
  });

  return items;
}

const otherItems: Item[] = [
  {
    id: "part-1",
    name: "角鐵固定座",
    category: "鋼構配件",
    categoryId: "parts",
    isActive: true,
  },
  {
    id: "bolt-1",
    name: "六角螺絲 M12×30",
    category: "螺絲",
    categoryId: "screw",
    steelType: "HEX_BOLT",
    isActive: true,
  },
  {
    id: "hbolt-1",
    name: "高張力螺栓 S10T M20",
    category: "螺絲",
    categoryId: "screw",
    steelType: "HIGH_TENSILE",
    isActive: true,
  },
  {
    id: "washer-1",
    name: "墊片 M16",
    category: "螺絲",
    categoryId: "screw",
    steelType: "WASHER",
    isActive: true,
  },
  {
    id: "nut-1",
    name: "六角螺帽 M16",
    category: "螺絲",
    categoryId: "screw",
    steelType: "HEX_NUT",
    isActive: true,
  },
  {
    id: "weld-1",
    name: "焊條 E7018 Ø3.2",
    category: "鋼構耗材",
    categoryId: "consumables",
    isActive: true,
  },
  {
    id: "hard-1",
    name: "輪子 4吋",
    category: "五金配件",
    categoryId: "hardware",
    isActive: true,
  },
  {
    id: "hard-2",
    name: "角尺 300mm",
    category: "五金配件",
    categoryId: "hardware",
    isActive: true,
  },
  {
    id: "hard-3",
    name: "米尺 5M",
    category: "五金配件",
    categoryId: "hardware",
    isActive: true,
  },
];

export const initialItems: Item[] = [
  ...presetSteelItems,
  ...generateSteelItems(),
  ...otherItems,
];
